import { useTranslation } from 'react-i18next';
import { Chip } from '@glplus/glpweb-dsl';
import type { LocationStatus } from '../lib/vendorApiClient';

/**
 * Location status (Figma Components → Status chip): Live (green tint, greenInk
 * text) · Verifying (orange tint, orangeInk text) · Needs changes (red outline).
 */
const SPEC: Record<LocationStatus, { key: string; bg: string; fg: string }> = {
  live: { key: 'live', bg: '#EAF5EA', fg: '#1F7026' },
  verifying: { key: 'verifying', bg: '#FEF1E7', fg: '#A85200' },
  needs_changes: { key: 'needsChanges', bg: '#FFFFFF', fg: '#C62828' },
};

export default function LocationStatusChip({ status, size = 'small' }: { status: LocationStatus | null; size?: 'small' | 'medium' }) {
  const { t } = useTranslation();
  if (!status) return null;
  const s = SPEC[status];
  return (
    <Chip
      label={`● ${t(`locations.status.${s.key}`)}`}
      size={size}
      backgroundColor={s.bg}
      textColor={s.fg}
      fontSize={12}
      sx={status === 'needs_changes' ? { border: '1px solid #C62828' } : undefined}
    />
  );
}
